/* eslint-disable */

// Fully flattens:
// - dragged folders
// - nested folders
// - FileSystemDirectoryEntry
// - FileSystemFileEntry
// - weird OS folder wrappers
// - ignores directories

export async function flattenItems(items: FileList | File[]): Promise<File[]> {
  const list: File[] = [];

  const helpers = {
    async traverseEntry(entry: any, curPath = "") {
      const name = entry.name || "";
      const nextPath = curPath ? `${curPath}/${name}` : name;

      if (entry.isFile) {
        await new Promise<void>((resolve) => {
          entry.file((file: File) => {
            // Preserve a webkitRelativePath-like property so downstream
            // code can detect original folder structure. Many browsers
            // provide this on files from <input webkitdirectory>.
            try {
              (file as any).webkitRelativePath = nextPath;
            } catch (e) {
              // ignore
            }
            list.push(file);
            resolve();
          });
        });
      } else if (entry.isDirectory) {
        const reader = entry.createReader();
        const entries = await new Promise<any[]>((resolve) => {
          reader.readEntries(resolve);
        });
        for (const e of entries) {
          await helpers.traverseEntry(e, nextPath);
        }
      }
    },

    async traverseFile(item: File) {
      // If it's a real file, just push it
      list.push(item);
    }
  };

  // Detect if browser gave us FileSystemEntries
  const fromDataTransfer = (items as any)[0]?.webkitGetAsEntry;

  if (fromDataTransfer) {
    // Handle drag-and-drop folder entries
    for (const item of items as any) {
      const entry = item.webkitGetAsEntry?.();
      if (entry) {
        await helpers.traverseEntry(entry, "");
      }
    }
  } else {
    // Handle folder upload via input (webkitdirectory) or plain FileList
    for (const file of items as File[]) {
      // ensure webkitRelativePath is present when provided by the input
      if ((file as any).webkitRelativePath) {
        // already has path
        list.push(file);
      } else {
        await helpers.traverseFile(file);
      }
    }
  }

  return list;
}
